var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhatsAppUsEn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 489,
    zoomAndPan: "magnify",
    viewBox: "0 0 366.75 82.499998",
    height: 110,
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "975ce5f3fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.980469 0 L 365.519531 0 L 365.519531 82.003906 L 0.980469 82.003906 Z M 0.980469 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a8d023f22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 208.175781 0 L 365.519531 0 L 365.519531 82.003906 L 208.175781 82.003906 Z M 208.175781 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3f77c02c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 251.414062 0 L 322.28125 0 C 333.75 0 344.75 4.554688 352.855469 12.664062 C 360.964844 20.773438 365.519531 31.769531 365.519531 43.238281 L 365.519531 93.691406 C 365.519531 105.160156 360.964844 116.15625 352.855469 124.265625 C 344.75 132.375 333.75 136.929688 322.28125 136.929688 L 251.414062 136.929688 C 239.945312 136.929688 228.949219 132.375 220.839844 124.265625 C 212.730469 116.15625 208.175781 105.160156 208.175781 93.691406 L 208.175781 43.238281 C 208.175781 31.769531 212.730469 20.773438 220.839844 12.664062 C 228.949219 4.554688 239.945312 0 251.414062 0 Z M 251.414062 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "02fa2da522"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.980469 0 L 158.324219 0 L 158.324219 82 L 0.980469 82 Z M 0.980469 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "429ba3395d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.21875 -92.261719 L 115.085938 -92.261719 C 126.554688 -92.261719 137.550781 -87.707031 145.660156 -79.597656 C 153.769531 -71.488281 158.324219 -60.492188 158.324219 -49.023438 L 158.324219 38.765625 C 158.324219 50.234375 153.769531 61.230469 145.660156 69.339844 C 137.550781 77.449219 126.554688 82.003906 115.085938 82.003906 L 44.21875 82.003906 C 32.75 82.003906 21.753906 77.449219 13.644531 69.339844 C 5.535156 61.230469 0.980469 50.234375 0.980469 38.765625 L 0.980469 -49.023438 C 0.980469 -60.492188 5.535156 -71.488281 13.644531 -79.597656 C 21.753906 -87.707031 32.75 -92.261719 44.21875 -92.261719 Z M 44.21875 -92.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4bf3e98536"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.484375 0 L 289.96875 0 L 289.96875 82.003906 L 53.484375 82.003906 Z M 53.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.0000493991,
    gradientTransform: "matrix(0.0563595, 0, 0, 0.0563595, 53.48577, 0)",
    y1: 727.5,
    x2: 4196.000177,
    gradientUnits: "userSpaceOnUse",
    y2: 727.5,
    id: "22b5df9403"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 20.399475%, 20.399475%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.491028%, 20.49408%, 20.497131%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.674133%, 20.683289%, 20.692444%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.857239%, 20.874023%, 20.889282%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.04187%, 21.063232%, 21.084595%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.224976%, 21.252441%, 21.281433%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.408081%, 21.443176%, 21.476746%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.592712%, 21.632385%, 21.673584%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.775818%, 21.82312%, 21.868896%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.958923%, 22.012329%, 22.065735%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.143555%, 22.203064%, 22.261047%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.32666%, 22.392273%, 22.457886%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.509766%, 22.581482%, 22.653198%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 22.772217%, 22.850037%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.877502%, 22.961426%, 23.045349%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.060608%, 23.152161%, 23.242188%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.245239%, 23.34137%, 23.4375%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.428345%, 23.530579%, 23.634338%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.61145%, 23.721313%, 23.829651%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.796082%, 23.910522%, 24.026489%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.979187%, 24.101257%, 24.221802%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.162292%, 24.290466%, 24.41864%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.345398%, 24.481201%, 24.615479%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.530029%, 24.67041%, 24.810791%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.713135%, 24.859619%, 25.007629%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.89624%, 25.050354%, 25.202942%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.080872%, 25.239563%, 25.39978%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.263977%, 25.430298%, 25.595093%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.447083%, 25.619507%, 25.791931%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.631714%, 25.808716%, 25.987244%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.814819%, 25.999451%, 26.184082%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.997925%, 26.18866%, 26.379395%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.182556%, 26.379395%, 26.576233%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.365662%, 26.568604%, 26.771545%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.548767%, 26.757812%, 26.968384%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.733398%, 26.948547%, 27.163696%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.916504%, 27.137756%, 27.360535%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.099609%, 27.328491%, 27.555847%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.284241%, 27.5177%, 27.752686%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.467346%, 27.708435%, 27.947998%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.650452%, 27.897644%, 28.144836%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.835083%, 28.086853%, 28.340149%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.018188%, 28.277588%, 28.536987%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.201294%, 28.466797%, 28.7323%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.384399%, 28.657532%, 28.929138%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.569031%, 28.846741%, 29.124451%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.752136%, 29.03595%, 29.321289%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.935242%, 29.226685%, 29.516602%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.119873%, 29.415894%, 29.71344%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.302979%, 29.606628%, 29.908752%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.486084%, 29.795837%, 30.105591%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.670715%, 29.985046%, 30.300903%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.853821%, 30.175781%, 30.497742%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.036926%, 30.36499%, 30.693054%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.221558%, 30.555725%, 30.889893%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.404663%, 30.744934%, 31.085205%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.587769%, 30.935669%, 31.282043%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.7724%, 31.124878%, 31.477356%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.955505%, 31.314087%, 31.674194%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.138611%, 31.504822%, 31.869507%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.323242%, 31.694031%, 32.066345%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.506348%, 31.884766%, 32.261658%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.689453%, 32.073975%, 32.458496%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.872559%, 32.263184%, 32.653809%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.05719%, 32.453918%, 32.850647%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.240295%, 32.643127%, 33.045959%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.423401%, 32.833862%, 33.242798%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.608032%, 33.023071%, 33.43811%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.791138%, 33.21228%, 33.634949%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.974243%, 33.403015%, 33.830261%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.158875%, 33.592224%, 34.0271%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.34198%, 33.782959%, 34.222412%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.525085%, 33.972168%, 34.41925%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.709717%, 34.162903%, 34.614563%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.892822%, 34.352112%, 34.811401%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.075928%, 34.541321%, 35.006714%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.260559%, 34.732056%, 35.203552%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.443665%, 34.921265%, 35.398865%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.62677%, 35.112%, 35.595703%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.811401%, 35.301208%, 35.791016%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.994507%, 35.490417%, 35.987854%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.177612%, 35.681152%, 36.183167%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.360718%, 35.870361%, 36.380005%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.545349%, 36.061096%, 36.576843%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.728455%, 36.250305%, 36.772156%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.91156%, 36.439514%, 36.968994%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.096191%, 36.630249%, 37.164307%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.279297%, 36.819458%, 37.361145%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.462402%, 37.010193%, 37.556458%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.647034%, 37.199402%, 37.753296%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.830139%, 37.390137%, 37.948608%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.013245%, 37.579346%, 38.145447%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.197876%, 37.768555%, 38.340759%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.380981%, 37.95929%, 38.537598%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.564087%, 38.148499%, 38.73291%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.748718%, 38.339233%, 38.929749%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.931824%, 38.528442%, 39.125061%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.114929%, 38.717651%, 39.321899%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.299561%, 38.908386%, 39.517212%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.482666%, 39.097595%, 39.71405%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.665771%, 39.28833%, 39.909363%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.848877%, 39.477539%, 40.106201%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.033508%, 39.666748%, 40.301514%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.216614%, 39.857483%, 40.498352%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.399719%, 40.046692%, 40.693665%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.584351%, 40.237427%, 40.890503%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.767456%, 40.426636%, 41.085815%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.950562%, 40.617371%, 41.282654%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.135193%, 40.80658%, 41.477966%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.318298%, 40.995789%, 41.674805%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.501404%, 41.186523%, 41.870117%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.686035%, 41.375732%, 42.066956%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.869141%, 41.566467%, 42.262268%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.052246%, 41.755676%, 42.459106%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.236877%, 41.944885%, 42.654419%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.419983%, 42.13562%, 42.851257%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.603088%, 42.324829%, 43.04657%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.78772%, 42.515564%, 43.243408%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.970825%, 42.704773%, 43.438721%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.153931%, 42.893982%, 43.635559%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.337036%, 43.084717%, 43.830872%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.521667%, 43.273926%, 44.02771%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.704773%, 43.464661%, 44.223022%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.887878%, 43.65387%, 44.419861%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.07251%, 43.844604%, 44.615173%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.255615%, 44.033813%, 44.812012%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.438721%, 44.223022%, 45.007324%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.623352%, 44.413757%, 45.204163%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.806458%, 44.602966%, 45.399475%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "79ed93eb24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.613281 12.96875 L 93.410156 12.96875 L 93.410156 64.519531 L 34.613281 64.519531 Z M 34.613281 12.96875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6a07144fc2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.230469 12.96875 L 71.765625 12.96875 C 77.5 12.96875 82.996094 15.246094 87.050781 19.300781 C 91.105469 23.355469 93.382812 28.855469 93.382812 34.585938 L 93.382812 42.898438 C 93.382812 48.632812 91.105469 54.132812 87.050781 58.1875 C 82.996094 62.238281 77.5 64.519531 71.765625 64.519531 L 56.230469 64.519531 C 50.496094 64.519531 45 62.238281 40.945312 58.1875 C 36.890625 54.132812 34.613281 48.632812 34.613281 42.898438 L 34.613281 34.585938 C 34.613281 28.855469 36.890625 23.355469 40.945312 19.300781 C 45 15.246094 50.496094 12.96875 56.230469 12.96875 Z M 56.230469 12.96875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d7d4a8ca5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.40625 19.230469 L 84.675781 19.230469 L 84.675781 58.246094 L 43.40625 58.246094 Z M 43.40625 19.230469 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#975ce5f3fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.980469 0 L 365.519531 0 L 365.519531 82.003906 L 0.980469 82.003906 Z M 0.980469 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.980469 0 L 365.519531 0 L 365.519531 82.003906 L 0.980469 82.003906 Z M 0.980469 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a8d023f22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3f77c02c7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707274",
    d: "M 208.175781 0 L 365.511719 0 L 365.511719 136.929688 L 208.175781 136.929688 Z M 208.175781 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02fa2da522)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#429ba3395d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M 0.980469 -92.261719 L 158.324219 -92.261719 L 158.324219 81.996094 L 0.980469 81.996094 Z M 0.980469 -92.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4bf3e98536)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#22b5df9403)",
    d: "M 53.484375 0 L 53.484375 82.003906 L 289.96875 82.003906 L 289.96875 0 Z M 53.484375 0 ",
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79ed93eb24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6a07144fc2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 34.613281 12.96875 L 93.410156 12.96875 L 93.410156 64.519531 L 34.613281 64.519531 Z M 34.613281 12.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d7d4a8ca5a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 47.300781 14.289062 C 42.59375 14.289062 38.804688 18.078125 38.804688 22.78125 L 38.804688 55.023438 C 38.804688 59.730469 42.59375 63.519531 47.300781 63.519531 L 79.542969 63.519531 C 84.246094 63.519531 88.035156 59.730469 88.035156 55.023438 L 88.035156 22.78125 C 88.035156 18.078125 84.246094 14.289062 79.542969 14.289062 Z M 47.300781 14.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1ba553",
    d: "M 64.042969 20.796875 C 59.417969 20.796875 54.980469 22.632812 51.710938 25.902344 C 48.441406 29.175781 46.601562 33.609375 46.601562 38.238281 C 46.621094 41.273438 47.4375 44.253906 48.960938 46.882812 C 48.9375 46.917969 48.917969 46.957031 48.914062 46.988281 C 48.859375 47.363281 47.625 51.78125 46.917969 54.148438 C 46.46875 55.660156 46.453125 55.816406 46.757812 55.816406 C 46.878906 55.816406 48.929688 55.300781 51.308594 54.675781 C 54.105469 53.941406 55.105469 53.671875 55.726562 53.515625 C 58.273438 54.917969 61.132812 55.664062 64.042969 55.679688 C 68.671875 55.679688 73.105469 53.839844 76.378906 50.570312 C 79.648438 47.300781 81.484375 42.863281 81.484375 38.238281 C 81.484375 35.945312 81.035156 33.679688 80.160156 31.5625 C 79.28125 29.445312 77.996094 27.523438 76.378906 25.902344 C 74.757812 24.285156 72.835938 23 70.71875 22.121094 C 68.601562 21.246094 66.335938 20.796875 64.042969 20.796875 Z M 64.042969 23.289062 C 66.007812 23.289062 67.953125 23.675781 69.765625 24.425781 C 71.578125 25.175781 73.226562 26.277344 74.613281 27.667969 C 76.003906 29.054688 77.105469 30.703125 77.855469 32.515625 C 78.605469 34.328125 78.992188 36.273438 78.992188 38.238281 C 78.992188 42.203125 77.417969 46.003906 74.613281 48.808594 C 71.8125 51.609375 68.007812 53.1875 64.042969 53.1875 C 61.082031 53.175781 58.1875 52.28125 55.730469 50.621094 L 52.628906 51.40625 C 52.625 51.410156 52.613281 51.410156 52.609375 51.414062 C 51.957031 51.5625 50.699219 51.867188 50.648438 51.816406 C 50.597656 51.761719 50.753906 51.0625 51.058594 49.789062 L 51.8125 46.800781 C 50.050781 44.292969 49.101562 41.304688 49.09375 38.238281 C 49.09375 34.273438 50.671875 30.46875 53.472656 27.667969 C 56.277344 24.863281 60.078125 23.289062 64.042969 23.289062 Z M 58.261719 29.953125 C 57.726562 29.980469 57.128906 30.222656 56.667969 30.640625 C 55.601562 31.613281 55.21875 32.507812 55.214844 34.066406 C 55.203125 36.253906 56.433594 38.503906 59.21875 41.40625 C 61.5625 43.851562 63.332031 44.996094 66.367188 46.027344 C 68.050781 46.601562 68.613281 46.648438 69.929688 46.316406 C 70.503906 46.171875 71.191406 45.769531 71.765625 45.242188 C 72.570312 44.503906 72.703125 44.265625 72.808594 43.332031 L 72.875 42.746094 C 72.890625 42.539062 72.699219 42.175781 72.417969 42.015625 L 71.023438 41.339844 C 69.976562 40.828125 68.925781 40.410156 68.6875 40.410156 C 68.253906 40.410156 67.871094 40.757812 67.230469 41.734375 C 66.589844 42.714844 66.300781 42.726562 64.554688 41.851562 C 62.757812 40.949219 60.808594 39.167969 60.003906 37.6875 L 59.671875 37.074219 C 59.59375 36.929688 59.601562 36.675781 59.6875 36.558594 L 60.261719 35.804688 C 60.671875 35.269531 61.007812 34.671875 61.007812 34.484375 C 61.007812 33.988281 59.414062 30.335938 59.113281 30.144531 C 58.882812 29.996094 58.582031 29.9375 58.261719 29.953125 Z M 58.261719 29.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.299126, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.546875 0 L 6.828125 0 L 1.296875 -24.125 L 4.109375 -24.125 L 8.640625 -4.171875 L 9.0625 -4.171875 L 14.46875 -24.125 L 17.09375 -24.125 L 22.515625 -4.171875 L 22.921875 -4.171875 L 27.46875 -24.125 L 30.203125 -24.125 L 24.6875 0 L 20.953125 0 L 15.921875 -18.265625 L 15.578125 -18.265625 Z M 10.546875 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.796975, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.171875 0 L 3.171875 -25.515625 L 5.859375 -25.515625 L 5.859375 -15.609375 L 6.203125 -15.546875 C 7.503906 -17.546875 9.378906 -18.546875 11.828125 -18.546875 C 14.015625 -18.546875 15.597656 -17.988281 16.578125 -16.875 C 17.566406 -15.757812 18.0625 -14.039062 18.0625 -11.71875 L 18.0625 0 L 15.375 0 L 15.375 -11.65625 C 15.375 -12.75 15.234375 -13.628906 14.953125 -14.296875 C 14.671875 -14.960938 14.234375 -15.445312 13.640625 -15.75 C 13.054688 -16.050781 12.289062 -16.203125 11.34375 -16.203125 C 9.6875 -16.203125 8.359375 -15.664062 7.359375 -14.59375 C 6.359375 -13.53125 5.859375 -11.78125 5.859375 -9.34375 L 5.859375 0 Z M 3.171875 0 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.751538, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.515625 0.34375 C 5.710938 0.34375 4.304688 -0.117188 3.296875 -1.046875 C 2.296875 -1.984375 1.796875 -3.320312 1.796875 -5.0625 C 1.796875 -6.144531 2.019531 -7.054688 2.46875 -7.796875 C 2.914062 -8.535156 3.601562 -9.140625 4.53125 -9.609375 C 5.46875 -10.078125 6.691406 -10.4375 8.203125 -10.6875 C 9.523438 -10.914062 10.53125 -11.164062 11.21875 -11.4375 C 11.90625 -11.707031 12.363281 -12.015625 12.59375 -12.359375 C 12.832031 -12.703125 12.953125 -13.128906 12.953125 -13.640625 C 12.953125 -14.472656 12.664062 -15.109375 12.09375 -15.546875 C 11.53125 -15.984375 10.625 -16.203125 9.375 -16.203125 C 8.195312 -16.203125 7.1875 -15.972656 6.34375 -15.515625 C 5.5 -15.054688 4.726562 -14.378906 4.03125 -13.484375 L 3.703125 -13.484375 L 2.375 -15.34375 C 3.144531 -16.320312 4.125 -17.097656 5.3125 -17.671875 C 6.5 -18.253906 7.851562 -18.546875 9.375 -18.546875 C 11.519531 -18.546875 13.097656 -18.078125 14.109375 -17.140625 C 15.128906 -16.203125 15.640625 -14.898438 15.640625 -13.234375 L 15.640625 -3.578125 C 15.640625 -2.566406 16.070312 -2.0625 16.9375 -2.0625 C 17.21875 -2.0625 17.488281 -2.113281 17.75 -2.21875 L 17.984375 -2.140625 L 18.296875 -0.28125 C 18.097656 -0.144531 17.835938 -0.046875 17.515625 0.015625 C 17.191406 0.0859375 16.859375 0.125 16.515625 0.125 C 15.515625 0.125 14.757812 -0.09375 14.25 -0.53125 C 13.738281 -0.96875 13.410156 -1.613281 13.265625 -2.46875 L 12.921875 -2.515625 C 12.398438 -1.554688 11.695312 -0.835938 10.8125 -0.359375 C 9.9375 0.109375 8.835938 0.34375 7.515625 0.34375 Z M 8.109375 -1.796875 C 9.117188 -1.796875 9.992188 -2.03125 10.734375 -2.5 C 11.472656 -2.96875 12.039062 -3.625 12.4375 -4.46875 C 12.832031 -5.320312 13.03125 -6.300781 13.03125 -7.40625 L 13.03125 -9.71875 L 12.71875 -9.78125 C 12.3125 -9.5 11.816406 -9.257812 11.234375 -9.0625 C 10.648438 -8.875 9.835938 -8.703125 8.796875 -8.546875 C 7.742188 -8.398438 6.90625 -8.175781 6.28125 -7.875 C 5.65625 -7.582031 5.207031 -7.207031 4.9375 -6.75 C 4.675781 -6.300781 4.546875 -5.738281 4.546875 -5.0625 C 4.546875 -4 4.859375 -3.1875 5.484375 -2.625 C 6.117188 -2.070312 6.992188 -1.796875 8.109375 -1.796875 Z M 8.109375 -1.796875 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.36315, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.3125 -2.890625 L 13.171875 -0.953125 C 12.742188 -0.523438 12.175781 -0.203125 11.46875 0.015625 C 10.769531 0.234375 10.015625 0.34375 9.203125 0.34375 C 5.734375 0.34375 4 -1.414062 4 -4.9375 L 4 -16 L 0.828125 -16 L 0.828125 -18.21875 L 4 -18.21875 L 4 -22.0625 L 6.6875 -22.515625 L 6.6875 -18.21875 L 12.546875 -18.21875 L 12.546875 -16 L 6.6875 -16 L 6.6875 -5.203125 C 6.6875 -3.109375 7.59375 -2.0625 9.40625 -2.0625 C 10.394531 -2.0625 11.25 -2.335938 11.96875 -2.890625 Z M 12.3125 -2.890625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.222861, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.296875 0.34375 C 7.148438 0.34375 6.085938 0.191406 5.109375 -0.109375 C 4.140625 -0.410156 3.320312 -0.820312 2.65625 -1.34375 C 1.988281 -1.875 1.515625 -2.472656 1.234375 -3.140625 L 2.828125 -4.78125 L 3.171875 -4.78125 C 3.765625 -3.882812 4.476562 -3.207031 5.3125 -2.75 C 6.144531 -2.289062 7.140625 -2.0625 8.296875 -2.0625 C 9.640625 -2.0625 10.660156 -2.320312 11.359375 -2.84375 C 12.054688 -3.363281 12.40625 -4.09375 12.40625 -5.03125 C 12.40625 -5.75 12.191406 -6.34375 11.765625 -6.8125 C 11.347656 -7.28125 10.664062 -7.628906 9.71875 -7.859375 L 6.65625 -8.609375 C 5.007812 -9.003906 3.8125 -9.628906 3.0625 -10.484375 C 2.3125 -11.347656 1.9375 -12.414062 1.9375 -13.6875 C 1.9375 -14.675781 2.1875 -15.535156 2.6875 -16.265625 C 3.195312 -16.992188 3.925781 -17.554688 4.875 -17.953125 C 5.820312 -18.347656 6.953125 -18.546875 8.265625 -18.546875 C 9.941406 -18.546875 11.257812 -18.3125 12.21875 -17.84375 C 13.175781 -17.375 13.925781 -16.722656 14.46875 -15.890625 L 12.953125 -14.40625 L 12.625 -14.40625 C 12.039062 -15.070312 11.40625 -15.550781 10.71875 -15.84375 C 10.03125 -16.144531 9.210938 -16.296875 8.265625 -16.296875 C 7.066406 -16.296875 6.144531 -16.082031 5.5 -15.65625 C 4.863281 -15.226562 4.546875 -14.609375 4.546875 -13.796875 C 4.546875 -13.054688 4.769531 -12.460938 5.21875 -12.015625 C 5.675781 -11.566406 6.46875 -11.203125 7.59375 -10.921875 L 10.609375 -10.203125 C 12.191406 -9.828125 13.332031 -9.203125 14.03125 -8.328125 C 14.738281 -7.460938 15.09375 -6.375 15.09375 -5.0625 C 15.09375 -4 14.835938 -3.054688 14.328125 -2.234375 C 13.828125 -1.421875 13.066406 -0.785156 12.046875 -0.328125 C 11.023438 0.117188 9.773438 0.34375 8.296875 0.34375 Z M 8.296875 0.34375 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.052511, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 21.71875 0 L 18.6875 0 L 16.453125 -6.625 L 6.171875 -6.625 L 3.921875 0 L 0.953125 0 L 9.375 -24.125 L 13.296875 -24.125 Z M 11.109375 -21.203125 L 6.96875 -9 L 15.640625 -9 L 11.515625 -21.203125 Z M 11.109375 -21.203125 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.723038, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.171875 7.375 L 3.171875 -18.203125 L 5.859375 -18.203125 L 5.859375 -15.484375 L 6.203125 -15.40625 C 7.554688 -17.5 9.539062 -18.546875 12.15625 -18.546875 C 13.675781 -18.546875 15.003906 -18.195312 16.140625 -17.5 C 17.273438 -16.8125 18.15625 -15.757812 18.78125 -14.34375 C 19.40625 -12.9375 19.71875 -11.1875 19.71875 -9.09375 C 19.71875 -7.007812 19.382812 -5.265625 18.71875 -3.859375 C 18.0625 -2.453125 17.148438 -1.398438 15.984375 -0.703125 C 14.816406 -0.00390625 13.476562 0.34375 11.96875 0.34375 C 10.726562 0.34375 9.628906 0.128906 8.671875 -0.296875 C 7.722656 -0.722656 6.898438 -1.425781 6.203125 -2.40625 L 5.859375 -2.34375 L 5.859375 7.375 Z M 11.375 -2.0625 C 15.0625 -2.0625 16.90625 -4.40625 16.90625 -9.09375 C 16.90625 -13.789062 15.0625 -16.140625 11.375 -16.140625 C 10.289062 -16.140625 9.335938 -15.890625 8.515625 -15.390625 C 7.691406 -14.898438 7.039062 -14.128906 6.5625 -13.078125 C 6.09375 -12.023438 5.859375 -10.695312 5.859375 -9.09375 C 5.859375 -7.5 6.09375 -6.175781 6.5625 -5.125 C 7.039062 -4.070312 7.691406 -3.296875 8.515625 -2.796875 C 9.335938 -2.304688 10.289062 -2.0625 11.375 -2.0625 Z M 11.375 -2.0625 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.436586, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.171875 7.375 L 3.171875 -18.203125 L 5.859375 -18.203125 L 5.859375 -15.484375 L 6.203125 -15.40625 C 7.554688 -17.5 9.539062 -18.546875 12.15625 -18.546875 C 13.675781 -18.546875 15.003906 -18.195312 16.140625 -17.5 C 17.273438 -16.8125 18.15625 -15.757812 18.78125 -14.34375 C 19.40625 -12.9375 19.71875 -11.1875 19.71875 -9.09375 C 19.71875 -7.007812 19.382812 -5.265625 18.71875 -3.859375 C 18.0625 -2.453125 17.148438 -1.398438 15.984375 -0.703125 C 14.816406 -0.00390625 13.476562 0.34375 11.96875 0.34375 C 10.726562 0.34375 9.628906 0.128906 8.671875 -0.296875 C 7.722656 -0.722656 6.898438 -1.425781 6.203125 -2.40625 L 5.859375 -2.34375 L 5.859375 7.375 Z M 11.375 -2.0625 C 15.0625 -2.0625 16.90625 -4.40625 16.90625 -9.09375 C 16.90625 -13.789062 15.0625 -16.140625 11.375 -16.140625 C 10.289062 -16.140625 9.335938 -15.890625 8.515625 -15.390625 C 7.691406 -14.898438 7.039062 -14.128906 6.5625 -13.078125 C 6.09375 -12.023438 5.859375 -10.695312 5.859375 -9.09375 C 5.859375 -7.5 6.09375 -6.175781 6.5625 -5.125 C 7.039062 -4.070312 7.691406 -3.296875 8.515625 -2.796875 C 9.335938 -2.304688 10.289062 -2.0625 11.375 -2.0625 Z M 11.375 -2.0625 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.150133, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.432961, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.4375 0.34375 C 9.476562 0.34375 7.238281 -0.40625 5.71875 -1.90625 C 4.207031 -3.40625 3.453125 -5.628906 3.453125 -8.578125 L 3.453125 -24.125 L 6.265625 -24.125 L 6.265625 -8.609375 C 6.265625 -6.503906 6.773438 -4.921875 7.796875 -3.859375 C 8.816406 -2.804688 10.363281 -2.28125 12.4375 -2.28125 C 16.550781 -2.28125 18.609375 -4.390625 18.609375 -8.609375 L 18.609375 -24.125 L 21.4375 -24.125 L 21.4375 -8.578125 C 21.4375 -5.628906 20.675781 -3.40625 19.15625 -1.90625 C 17.632812 -0.40625 15.394531 0.34375 12.4375 0.34375 Z M 12.4375 0.34375 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.297948, 48.161049)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.296875 0.34375 C 7.148438 0.34375 6.085938 0.191406 5.109375 -0.109375 C 4.140625 -0.410156 3.320312 -0.820312 2.65625 -1.34375 C 1.988281 -1.875 1.515625 -2.472656 1.234375 -3.140625 L 2.828125 -4.78125 L 3.171875 -4.78125 C 3.765625 -3.882812 4.476562 -3.207031 5.3125 -2.75 C 6.144531 -2.289062 7.140625 -2.0625 8.296875 -2.0625 C 9.640625 -2.0625 10.660156 -2.320312 11.359375 -2.84375 C 12.054688 -3.363281 12.40625 -4.09375 12.40625 -5.03125 C 12.40625 -5.75 12.191406 -6.34375 11.765625 -6.8125 C 11.347656 -7.28125 10.664062 -7.628906 9.71875 -7.859375 L 6.65625 -8.609375 C 5.007812 -9.003906 3.8125 -9.628906 3.0625 -10.484375 C 2.3125 -11.347656 1.9375 -12.414062 1.9375 -13.6875 C 1.9375 -14.675781 2.1875 -15.535156 2.6875 -16.265625 C 3.195312 -16.992188 3.925781 -17.554688 4.875 -17.953125 C 5.820312 -18.347656 6.953125 -18.546875 8.265625 -18.546875 C 9.941406 -18.546875 11.257812 -18.3125 12.21875 -17.84375 C 13.175781 -17.375 13.925781 -16.722656 14.46875 -15.890625 L 12.953125 -14.40625 L 12.625 -14.40625 C 12.039062 -15.070312 11.40625 -15.550781 10.71875 -15.84375 C 10.03125 -16.144531 9.210938 -16.296875 8.265625 -16.296875 C 7.066406 -16.296875 6.144531 -16.082031 5.5 -15.65625 C 4.863281 -15.226562 4.546875 -14.609375 4.546875 -13.796875 C 4.546875 -13.054688 4.769531 -12.460938 5.21875 -12.015625 C 5.675781 -11.566406 6.46875 -11.203125 7.59375 -10.921875 L 10.609375 -10.203125 C 12.191406 -9.828125 13.332031 -9.203125 14.03125 -8.328125 C 14.738281 -7.460938 15.09375 -6.375 15.09375 -5.0625 C 15.09375 -4 14.835938 -3.054688 14.328125 -2.234375 C 13.828125 -1.421875 13.066406 -0.785156 12.046875 -0.328125 C 11.023438 0.117188 9.773438 0.34375 8.296875 0.34375 Z M 8.296875 0.34375 "
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhatsAppUsEn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/whatsApp_us_en.d0abfc9e603751ecbaf63b3ea35127b2.svg";